import createLucideIcon from '../createLucideIcon';

/**
 * @component @name IterationCw
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxMGE4IDggMCAxIDEgOCA4SDQiIC8+CiAgPHBhdGggZD0ibTggMjItNC00IDQtNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/iteration-cw
 * @see https://lucide.dev/guide/packages/lucide-vue - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {Component} Vue Component
 *
 */
const IterationCw = createLucideIcon('IterationCwIcon', [
  ['path', { d: 'M4 10a8 8 0 1 1 8 8H4', key: 'svv66n' }],
  ['path', { d: 'm8 22-4-4 4-4', key: '6g7gki' }],
]);

export default IterationCw;
